var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t("controls"),
      _vm._v(" "),
      _c("div", { staticClass: "p-2" }, [
        _c(
          "div",
          { staticClass: "item-title border-bottom mb-2" },
          [_vm._t("header")],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "overflow-hidden", style: _vm.styles }, [
          _c("div", { ref: "body" }, [_vm._t("body")], 2),
        ]),
        _vm._v(" "),
        _vm.isToggleBodyButtonVisible
          ? _c("div", { staticClass: "d-flex justify-content-center mt-2" }, [
              _c(
                "div",
                {
                  staticClass:
                    "btn btn-small btn-invisible line-height-10 py-0",
                  attrs: { title: _vm.toggleBodyButtonTitle },
                  on: { click: _vm.toggleBodyExpand },
                },
                [
                  _vm.isBodyExpanded
                    ? _c("i", { staticClass: "fas fa-chevron-up text-muted" })
                    : _c("i", {
                        staticClass: "fas fa-chevron-down text-muted",
                      }),
                ]
              ),
            ])
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }